module.exports = __webpack_public_path__ + "img/time.c2feea88.svg";